export const SURVEY_TYPE_REMINDER_LIMITS: Record<string, number> = Object.freeze({
  STANDARD: 30,
  ONBOARDING: 7,
});
